// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Un-z","imageAndVideoCount":"Vn-z","imageAndVideoContainer":"Wn-z","viewAllReviews":"Xn-z"};